// Themes can be added, removed,and altered by editing this object
// Available attributes for the themes can be found below
// Current initial map setting is for the first attribute of the first theme
export const themeGroupings = [
  { id: 0, initAttr: 2001, mdFolder: 'coastal_hazards', name: 'Coastal Hazards' },
  { id: 1, initAttr: 1012, mdFolder: 'extreme_rainfall-flooding', name: 'Extreme Rainfall/Flooding' },
  { id: 2, initAttr: 2003, mdFolder: 'fog', name: 'Fog' },
  { id: 3, initAttr: 2017, mdFolder: 'great_lakes_hazards', name: 'Great Lakes Hazards' },
  { id: 4, initAttr: 2011, mdFolder: 'severe_weather', name: 'Severe Weather' },
  { id: 5, initAttr: 2015, mdFolder: 'tropical_storms-hurricanes', name: 'Tropical Storms/Hurricanes' },
  { id: 6, initAttr: 1002, mdFolder: 'extreme_heat', name: 'Extreme Heat' },
  { id: 7, initAttr: 2026, mdFolder: 'wildfire', name: 'Wildfire' },
  { id: 8, initAttr: 1006, mdFolder: 'winter_weather', name: 'Winter Weather' },
];

export const selectThemeById = (id) => {
  return themeGroupings.find((theme) => theme.id === id);
};
